import { useEffect, useState } from "react";
import { Button, Input } from "reactstrap";
import comum from "../../helpers/comum";
import { MdAdd, MdCopyAll, MdDelete, MdRefresh } from "react-icons/md";
import api from "../../service/api";
import { useParams } from "react-router-dom";
import { toast } from "react-toastify";

function DynamicParam({
  value = [],
  onChange,
  dynamicInput,
  id_node,
  urlHide = false,
  title = "body",
  subtitle = "(JSON)",
  onRefreshParams = (id) => {},
  node_type = "",
}) {
  const [params, setParams] = useState(value ?? []);
  const { idPipeline } = useParams();
  const [nodes, onChangeNode] = dynamicInput;
  const URL_GERADA = `${api.getUri()}/api/webhook/${idPipeline}/${id_node}`;

  function add() {
    const myId = comum.GenerateId();
    setParams([...params, { id: myId, value: "" }]);

    onChangeNode(
      nodes.map((e) => {
        if (e.id === id_node) {
          return {
            ...e,

            params: [
              ...(e.params ?? []),
              {
                dataType: "text",
                id: myId,
                key: myId,
                label: "",
                type: "output",
                variable_type: "text",
                obrigatory: true,
              },
            ],
          };
        }
        return e;
      })
    );
  }

  function remove(id) {
    setParams(params.filter((param) => param.id !== id));

    onChangeNode(
      nodes.map((node) => {
        if (node.id === id_node) {
          return {
            ...node,
            params: node.params?.filter((param) => param.id !== id),
          };
        }
        return node;
      })
    );
  }

  function update(id, value) {
    setParams(
      params.map((e) => {
        if (e.id === id) {
          return {
            ...e,
            value,
          };
        }
        return e;
      })
    );

    onChangeNode(
      nodes.map((e) => {
        if (e.id === id_node) {
          return {
            ...e,
            params: e?.params?.map((param) => {
              if (param.id === id) {
                return {
                  ...param,
                  label: value,
                };
              }
              return param;
            }),
          };
        }
        return e;
      })
    );
  }

  function copyUrl() {
    comum.copyToClipboard(URL_GERADA);
    toast.success(`URL do WebHook foi copiada para sua área de transferência`);
  }

  useEffect(() => {
    if (params) {
      onChange(params);
    }
  }, [params]);

  return (
    <div>
      {!urlHide && (
        <div>
          <label style={{ fontSize: 13 }}>
            URL <label style={{ fontSize: 8 }}>(POST)</label>
          </label>
          <div style={{ display: "flex", gap: 5 }}>
            <Input type={"text"} disabled value={URL_GERADA} />
            <Button color="primary" onClick={() => copyUrl()}>
              <MdCopyAll size={12} />
            </Button>
          </div>
        </div>
      )}
      <div className="mt-2">
        <label style={{ fontSize: 13 }}>
          {title}
          <label style={{ fontSize: 8 }}>{subtitle}</label>
        </label>
        {params?.map((e) => (
          <div
            className="mt-2"
            style={{
              display: "flex",
              alignItems: "center",
              gap: 5,
              flexDirection: "row",
            }}
          >
            <Input
              type={"text"}
              value={e?.value}
              onChange={({ target }) => update(e.id, target.value)}
            />
            <Button size="sm" color="primary" onClick={() => remove(e.id)}>
              <MdDelete />
            </Button>
          </div>
        ))}
      </div>
      <div style={{ display: "flex", justifyContent: "space-between" }}>
        <Button
          style={{
            fontWeight: "600",
            fontSize: 11,
            alignItems: "center",
            display: "flex",
            gap: 3,
          }}
          className="mt-2"
          size="sm"
          color="primary"
          onClick={() => add()}
        >
          <MdAdd size={12} /> Nova Entrada
        </Button>
        {/* {node_type === "foreach" && ( */}
        <Button
          style={{
            fontWeight: "600",
            fontSize: 11,
            alignItems: "center",
            display: "flex",
            gap: 3,
          }}
          className="mt-2"
          size="sm"
          color="primary"
          onClick={() => onRefreshParams(id_node)}
        >
          <MdRefresh size={12} />
        </Button>
        {/* )} */}
      </div>
    </div>
  );
}

export default DynamicParam;
